import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advisory',
  templateUrl: './advisory.component.html',
  styleUrls: ['./advisory.component.css']
})
export class AdvisoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
